var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 7H6C3.75 7 2 8.74777 2 10.8571V30.1429C2 32.3125 3.75 34 6 34H34C36.1875 34 38 32.3125 38 30.1429V10.8571C38 8.74777 36.1875 7 34 7ZM5 10.8571C5 10.375 5.4375 9.89286 6 9.89286H33.9375C34.5 9.89286 34.9375 10.375 34.9375 10.8571V12.7857H5V10.8571ZM34.9375 30.1429C34.9375 30.6853 34.5 31.1071 33.9375 31.1071H6C5.4375 31.1071 5 30.6853 5 30.1429V18.5714H35L34.9375 30.1429ZM9.5 28.2143H12.5C13.3125 28.2143 13.9375 27.6116 13.9375 26.7679C13.9375 25.9844 13.3125 25.3214 12.5 25.3214H9.5C8.625 25.3214 8 25.9844 8 26.7679C8 27.6116 8.625 28.2143 9.5 28.2143ZM17.5 28.2143H24.5C25.3125 28.2143 26 27.6116 26 26.7679C26 25.9844 25.3125 25.3214 24.5 25.3214H17.5C16.625 25.3214 16 25.9844 16 26.7679C16 27.6116 16.625 28.2143 17.5 28.2143Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.18901c65203d2764a1fb3cbefa4ef4d0.svg";
export { ForwardRef as ReactComponent };